module.exports = __webpack_public_path__ + "img/pic_france_04.59b4ec64.jpg";